/* tslint:disable */
/* eslint-disable */
/**
 * Orders and payments
 * Placeholder description of the order & payment instruction service. Detailed description to be provided by Monavate team.
 *
 * The version of the OpenAPI document: 1.33.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CardShareResponse } from '../models';
// @ts-ignore
import type { CreateCardShareRequest } from '../models';
// @ts-ignore
import type { NotFoundError } from '../models';
// @ts-ignore
import type { ValidationError } from '../models';
// @ts-ignore
import type { ViewCardShareByToken } from '../models';
/**
 * CardSharesApi - axios parameter creator
 * @export
 */
export const CardSharesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new card share
         * @param {CreateCardShareRequest} createCardShareRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCardShare: async (createCardShareRequest: CreateCardShareRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createCardShareRequest' is not null or undefined
            assertParamExists('createCardShare', 'createCardShareRequest', createCardShareRequest)
            const localVarPath = `/card-shares`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCardShareRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary View shared card details by token
         * @param {string} xCardToken Access token for card share retrieval.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardShareByToken: async (xCardToken: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCardToken' is not null or undefined
            assertParamExists('getCardShareByToken', 'xCardToken', xCardToken)
            const localVarPath = `/card-share-by-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xCardToken != null) {
                localVarHeaderParameter['x-card-token'] = String(xCardToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary View shared card details
         * @param {string} [cardId] Filter by a card ID.
         * @param {string} [paymentId] Filter by a payment instruction ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardShares: async (cardId?: string, paymentId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/card-shares`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (cardId !== undefined) {
                localVarQueryParameter['cardId'] = cardId;
            }

            if (paymentId !== undefined) {
                localVarQueryParameter['paymentId'] = paymentId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CardSharesApi - functional programming interface
 * @export
 */
export const CardSharesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CardSharesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a new card share
         * @param {CreateCardShareRequest} createCardShareRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCardShare(createCardShareRequest: CreateCardShareRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CardShareResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCardShare(createCardShareRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CardSharesApi.createCardShare']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary View shared card details by token
         * @param {string} xCardToken Access token for card share retrieval.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCardShareByToken(xCardToken: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ViewCardShareByToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCardShareByToken(xCardToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CardSharesApi.getCardShareByToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary View shared card details
         * @param {string} [cardId] Filter by a card ID.
         * @param {string} [paymentId] Filter by a payment instruction ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCardShares(cardId?: string, paymentId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CardShareResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCardShares(cardId, paymentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CardSharesApi.getCardShares']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CardSharesApi - factory interface
 * @export
 */
export const CardSharesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CardSharesApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a new card share
         * @param {CardSharesApiCreateCardShareRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCardShare(requestParameters: CardSharesApiCreateCardShareRequest, options?: RawAxiosRequestConfig): AxiosPromise<CardShareResponse> {
            return localVarFp.createCardShare(requestParameters.createCardShareRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary View shared card details by token
         * @param {CardSharesApiGetCardShareByTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardShareByToken(requestParameters: CardSharesApiGetCardShareByTokenRequest, options?: RawAxiosRequestConfig): AxiosPromise<ViewCardShareByToken> {
            return localVarFp.getCardShareByToken(requestParameters.xCardToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary View shared card details
         * @param {CardSharesApiGetCardSharesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCardShares(requestParameters: CardSharesApiGetCardSharesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<CardShareResponse>> {
            return localVarFp.getCardShares(requestParameters.cardId, requestParameters.paymentId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createCardShare operation in CardSharesApi.
 * @export
 * @interface CardSharesApiCreateCardShareRequest
 */
export interface CardSharesApiCreateCardShareRequest {
    /**
     * 
     * @type {CreateCardShareRequest}
     * @memberof CardSharesApiCreateCardShare
     */
    readonly createCardShareRequest: CreateCardShareRequest
}

/**
 * Request parameters for getCardShareByToken operation in CardSharesApi.
 * @export
 * @interface CardSharesApiGetCardShareByTokenRequest
 */
export interface CardSharesApiGetCardShareByTokenRequest {
    /**
     * Access token for card share retrieval.
     * @type {string}
     * @memberof CardSharesApiGetCardShareByToken
     */
    readonly xCardToken: string
}

/**
 * Request parameters for getCardShares operation in CardSharesApi.
 * @export
 * @interface CardSharesApiGetCardSharesRequest
 */
export interface CardSharesApiGetCardSharesRequest {
    /**
     * Filter by a card ID.
     * @type {string}
     * @memberof CardSharesApiGetCardShares
     */
    readonly cardId?: string

    /**
     * Filter by a payment instruction ID.
     * @type {string}
     * @memberof CardSharesApiGetCardShares
     */
    readonly paymentId?: string
}

/**
 * CardSharesApi - object-oriented interface
 * @export
 * @class CardSharesApi
 * @extends {BaseAPI}
 */
export class CardSharesApi extends BaseAPI {
    /**
     * 
     * @summary Create a new card share
     * @param {CardSharesApiCreateCardShareRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardSharesApi
     */
    public createCardShare(requestParameters: CardSharesApiCreateCardShareRequest, options?: RawAxiosRequestConfig) {
        return CardSharesApiFp(this.configuration).createCardShare(requestParameters.createCardShareRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary View shared card details by token
     * @param {CardSharesApiGetCardShareByTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardSharesApi
     */
    public getCardShareByToken(requestParameters: CardSharesApiGetCardShareByTokenRequest, options?: RawAxiosRequestConfig) {
        return CardSharesApiFp(this.configuration).getCardShareByToken(requestParameters.xCardToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary View shared card details
     * @param {CardSharesApiGetCardSharesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardSharesApi
     */
    public getCardShares(requestParameters: CardSharesApiGetCardSharesRequest = {}, options?: RawAxiosRequestConfig) {
        return CardSharesApiFp(this.configuration).getCardShares(requestParameters.cardId, requestParameters.paymentId, options).then((request) => request(this.axios, this.basePath));
    }
}

